import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalPages: 0,
    walletHistoryData: [],
    scrollLoaderButton: false,
    dataLoader: false,
    total: 0,
}

const walletHistorySlice = createSlice({
    name: 'walletHistory',
    initialState,
    reducers: {
        defaultState(state, action) {
            return initialState
        },
        setWalletHistoryStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
        setWalletHistoryObject(state, action) {
            return { ...state, ...action?.payload }
        },
        setWalletHistoryData(state, action){
            state.walletHistoryData = action?.payload?.pagination 
                ? [...state.walletHistoryData, ...action?.payload?.walletHistoryData]
                : action?.payload?.walletHistoryData;
            state.total = action?.payload?.total;
            state.totalPages = action?.payload?.totalPages;
            state.page = action?.payload?.page;
            state.size = action?.payload?.size;
            state.scrollLoaderButton = action?.payload?.scrollLoaderButton;
            state.dataLoader = action?.payload?.dataLoader;
        },
        setDataLoader(state,action){
            state.dataLoader = action?.payload
        },  
        setWalletHistoryLoaderForButton(state, action) {
            state.scrollLoaderButton = action?.payload
        },   
    }
})

export const WalletHistoryActions = walletHistorySlice.actions;
export default walletHistorySlice